import { Accordion } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { useState } from 'react'
import styles from './DescriptionListing.module.sass'

interface Props {
  className?: string
  title: string
  description: string
  descriptionContent: string
}

const DescriptionListing = (props: Props) => {
  const { className = '', title, description, descriptionContent } = props
  const [isOpen, setIsOpen] = useState(false)

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      {!!descriptionContent && (
        <Accordion
          variant="more"
          labelClassName={styles.accordionLabel}
          className={styles.accordion}
          id="description_listing"
          label={isOpen ? t('Mostra meno') : t('Mostra di più')}
          contentPosition="top"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            className={styles.accordionContent}
            dangerouslySetInnerHTML={{ __html: descriptionContent }}
          />
        </Accordion>
      )}
    </div>
  )
}

export default DescriptionListing
